

import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class AttributeService extends BaseService {
	constructor() {
		super('/Attribute');
	}


	public getAllByFilter(filter: AttributeFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class AttributeFilter extends BaseFilter {
	constructor( idTenant?: number | null) {
		super();
		this._idTenant = idTenant;
	
		
	}

	private _idTenant?: number | null;
	
	

	public getAllParams(): {} {
	
		let data = Object.assign({},			
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
		);
	
		return data;
	};
}